import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#F9F8F6] border-t border-dotted border-zinc-300">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-14">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
        <div className="md:col-span-7">
          <h2 className="font-display font-900 tracking-tighter leading-[0.9] text-4xl sm:text-5xl lg:text-6xl">
            Vi ses i<br />
            <span className="font-editorial italic font-600">København</span>
          </h2>
          <p className="font-body text-base text-black/60 mt-5 max-w-md">
            The unofficial guide to Copenhagen — made by locals who live here, with rye bread and coffee. One city, known street by street.
          </p>
        </div>
        <div className="md:col-span-5 md:text-right">
          <div className="flex md:justify-end flex-wrap gap-x-6 gap-y-2 font-body font-700 text-sm">
            <a href="#planner" data-scroll="#planner" className="hover:text-[#DF3226] transition-colors">Planner</a>
            <Link to="/areas" className="hover:text-[#DF3226] transition-colors">Areas</Link>
            <Link to="/transport" data-testid="footer-transport-link" className="hover:text-[#DF3226] transition-colors">Transport</Link>
            <Link to="/stay" data-testid="footer-stay-link" className="hover:text-[#DF3226] transition-colors">Where to stay</Link>
            <Link to="/advertise" data-testid="footer-advertise-link" className="hover:text-[#DF3226] transition-colors">Advertise</Link>
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-[#DF3226] transition-colors">Terms</Link>
          </div>
          <p className="font-body text-xs text-black/40 mt-6">
            © {new Date().getFullYear()} CPH Highlights · All rights reserved. Not affiliated with the city of Copenhagen.
            {" · "}
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#DF3226] transition-colors">Admin</Link>
          </p>
        </div>
      </div>
    </div>
  </footer>
);
